import { render, staticRenderFns } from "./RootRicercaStanzeView.vue?vue&type=template&id=18306abd&"
import script from "./RootRicercaStanzeView.vue?vue&type=script&lang=ts&"
export * from "./RootRicercaStanzeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports